/** Case-insensitive substring filter; empty input → all options. */
export function filterSubstringOptions(options, { inputValue }) {
	const q = String(inputValue ?? '').trim().toLowerCase()
	if (!q) return options
	return options.filter((opt) => String(opt).toLowerCase().includes(q))
}

/** Prefer catalog casing; skip duplicates (case-insensitive). */
export function normalizeTagList(tags, catalog = []) {
	const result = []
	for (const raw of tags || []) {
		const trimmed = String(raw ?? '').trim()
		if (!trimmed) continue
		if (result.some((t) => t.toLowerCase() === trimmed.toLowerCase())) continue
		const catalogMatch = catalog.find(
			(t) => t.toLowerCase() === trimmed.toLowerCase()
		)
		result.push(catalogMatch || trimmed)
	}
	return result
}
